import styled from 'styled-components';
import { device, shadows } from '../../../utils/styled-component-mixins';

const SearchResultsPageStyled = styled.div`
  padding-bottom: 5.6rem;

  @media ${device.desktop} {
    padding-bottom: 10rem;
  }

  .search-controls-container {
    padding-top: 4rem;

    .filter-buttons {
      align-items: flex-end;
      display: flex;
      justify-content: space-between;

      @media ${device.desktop} {
        align-items: center;
        padding-right: 4.75rem;
      }

      .btn-wrapper {
        &:first-child {
          button {
            span:first-child {
              font-size: 1.6rem;
              line-height: 2.4rem;
            }
          }
        }
      }
    }

    .btn {
      &:active {
        outline: none;
      }
    }

    .clear-filters-btn-desktop {
      display: none;

      @media ${device.desktop} {
        display: flex;
      }
    }

    fieldset {
      border: none;
      margin: 0 0 0 2.5rem;
      padding: 0;

      legend {
        margin-right: 0.8rem;
        padding: 0;
      }
    }

    .view-controls {
      align-items: center;
      display: flex;

      .list-view-control,
      .grid-view-control {
        opacity: 0;
        position: absolute;

        + label {
          color: var(--cta-blue);
          cursor: pointer;
          font-family: 'Material Icons';
          font-feature-settings: 'liga';
          font-size: 2.4rem;
          height: 48px;
          padding: 1.2rem;
          position: relative;
          width: 48px;
        }

        &:checked + label {
          &:before {
            border-bottom: 2px solid var(--cta-blue);
          }
        }

        & + label:before {
          border-bottom: 2px solid transparent;
          line-height: 1;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }

        &:focus + label {
          border: 2px solid var(--cta-blue);
        }
      }

      .list-view-control + label:before {
        content: 'list';
      }

      .grid-view-control + label:before {
        content: 'grid_view';
      }
    }

    .row {
      &:last-child {
        p {
          @media ${device.deviceOnly} {
            margin-bottom: 0;
            margin-top: 4rem;
          }
        }
      }
    }
  }

  .filters-container {
    @media ${device.deviceOnly} {
      background-color: var(--white);
      display: block;
      left: 0%;
      height: 100vh;
      min-width: 100vw;
      overflow: scroll;
      position: absolute;
      top: 0;
      transform: translateX(var(--translate-x));
      width: 100%;
      z-index: 550;

      .mobile-filter-close {
        border: none;
        position: absolute;
        height: 4.8rem;
        padding: 0;
        right: 0.7rem;
        top: 0.7rem;
        width: 4.8rem;

        span {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .results-controls {
    align-items: center;
    display: flex;
    justify-content: space-between;

    p {
      margin: 0;
    }

    .select-input-wrapper {
      padding-left: 0;
      padding-right: 0;
    }

    .search-sort-view-controls {
      align-items: center;
      display: flex;
      margin-left: auto;
    }
  }

  .card-grid {
    display: grid;
    grid-template-rows: max-content;
    grid-gap: 1.6rem;
    isolation: isolate;
    margin-bottom: 5.6rem;
    margin-top: 2rem;
    position: relative;

    @media ${device.desktop} {
      grid-template-columns: repeat(auto-fill, minmax(35rem, 1fr));
      margin-bottom: 10rem;
      margin-top: 4.6rem;
    }
  }

  .card-grid {
    .overflow-wrapper {
      a {
        border-bottom: 2px solid transparent;
        margin-right: 3.2rem;
        position: relative;
        transition: background-size 0.3s;

        &::after {
          background-color: var(--button-tertiary);
          bottom: 0;
          content: '';
          display: block;
          height: 2px;
          left: 0;
          position: absolute;
          transition: width 0.3s;
          width: 0;
        }

        span[class*='material-icons'] {
          position: absolute;
          left: 100%;
        }
      }
    }

    .event-webinar-card-wrapper,
    .generic-card-wrapper {
      .animation-wrapper {
        p {
          @media ${device.deviceOnly} {
            font-size: 1.4rem;
          }
        }
      }
    }

    .insight-card,
    .event-webinar-card-wrapper,
    .generic-card-wrapper {
      h3 {
        font-weight: 800;

        @media ${device.deviceOnly} {
          font-size: 2rem;
          margin-bottom: 1.2rem;
        }
      }
    }

    .insight-card,
    .event-webinar-card-wrapper {
      .featured-card-content {
        *:not(a) {
          animation: none !important;
          transition: all 0.3s ease-in-out 0s !important;
        }

        .animation-wrapper {
          &::after {
            content: none;
          }

          a {
            color: var(--cta-blue);
            transform: none;
          }

          &.hover-in {
            animation: none;

            .overflow-wrapper {
              a {
                &:after {
                  width: 100%;
                }
              }
            }

            .overflow-wrapper * {
              color: var(--cta-blue);
            }

            .animated-content:not(.hide) {
              margin-top: calc(100% * var(--image-ratio) + 2.4rem) !important;

              * {
                color: var(--charcoal);
              }

              .tag {
                background-color: var(--white);
                border-color: var(--grey);
                color: var(--slate);
              }
            }
          }
        }
      }
    }

    .generic-card-wrapper {
      .animation-wrapper {
        &.hover-in {
          .overflow-wrapper {
            a {
              &:after {
                width: 100%;
              }
            }
          }
        }
      }
    }

    .insight-card {
      display: flex;
      flex-direction: column;

      .featured-card-image {
        @media ${device.deviceOnly} {
          padding-bottom: 0;
        }
      }

      .featured-card-content {
        min-height: 26rem;

        @media ${device.deviceOnly} {
          padding: 2.4rem 1.6rem;
        }

        @media ${device.desktop} {
          height: 100%;
          min-height: 31.2rem;
        }

        .animated-content.hide {
          display: none;
        }

        .animated-content {
          width: 100%;
        }

        .animation-wrapper {
          animation: none;
          align-items: flex-start;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;

          .animated-content {
            margin: 0;
            position: static;
          }

          .content-wrapper {
            p {
              display: block;
              opacity: 1;
              margin-top: 0.8rem;
            }

            .publish-date {
              margin-bottom: 1.2rem;

              @media ${device.desktop} {
                margin-bottom: 3rem;
              }
            }
          }

          &.hover-in {
            .content-wrapper {
              .animated-content:not(hide) {
                margin-top: 0 !important; // needed to override other !important
              }
            }
          }
        }
      }
    }

    .event-webinar-card-wrapper {
      ${shadows.cardShadow}
      width: 100%;

      @media ${device.desktop} {
        min-height: 54rem;
      }

      @media ${device.deviceOnly} {
        .featured-card-content {
          padding: 2.4rem 1.6rem;
        }
      }

      .event-time-location {
        @media ${device.deviceOnly} {
          margin-bottom: 1rem;
        }
      }

      .event-right-column {
        p {
          display: block;
        }
      }

      .hover-in {
        .event-left-column {
          time * {
            color: var(--charcoal-2);
          }
        }

        .event-right-column {
          time,
          h3,
          p {
            color: var(--charcoal);
          }

          .tag {
            background-color: var(--white);
            border-color: var(--grey);
            color: var(--charcoal-2);
          }
        }

        address span {
          color: var(--charcoal);
        }
      }
    }

    .generic-card-wrapper {
      ${shadows.cardShadow};
      height: 100%;

      @media ${device.desktop} {
        min-height: 54rem;
      }
    }

    div[class^='SkeletonCard'] {
      .insight-card {
        .featured-card-content {
          @media ${device.deviceOnly} {
            max-height: 26rem;
          }
        }
      }
    }
  }

  .mobile-filter-sort-controls {
    display: flex;
    justify-content: space-between;

    button {
      span:first-child {
        font-size: 1.6rem;
      }
    }

    .btn-wrapper:first-child {
      span:last-child {
        font-size: 2.4rem;
        left: -3.3rem;
      }
    }

    .btn-wrapper:last-child {
      span:first-child {
        margin-right: 1rem;
      }
    }
  }
`;

export default SearchResultsPageStyled;
